<template>

    <div :class="{ 'pointer-events-none': !$page.props.canManageSettings }">

        <a v-if="trigger" href="#" @click.prevent.stop="toggle" class="flex items-center font-medium flex-row">
            <div class="flex flex-grow items-center ">
                <img src="/img/zapier.svg" class="h-5 w-5 mr-2" />
                Use recordings as Trigger into Zapier
            </div>
            <div class="flex">
                <toggle :checked="enabled" @click.prevent.stop @update="toggleZapier"></toggle>
            </div>
        </a>
        <div v-else class="flex items-center font-bold">
            <img src="/img/zapier.svg" class="h-5 w-5 mr-2" />
            Use recordings as Trigger into Zapier
        </div>

        <div v-if="trigger" class="flex flex-col mt-3 text-sm">
            <div class="flex items-center">
                Installed into your Zap | <a :href="'https://zapier.com/app/editor/' + engine.zap_id"
                    title="Uninstall Zap" class="text-blue-500 mx-1 hover:underline hover:text-blue-600">uninstall</a>
            </div>
        </div>

        <div v-else class="flex flex-row mt-3">
            <div class="flex flex-grow items-center">
                Each incoming feedback will trigger your Zap
            </div>
            <div class="flex">
                <a href="https://api.zapier.com/v1/embed/birdie-screen-recording/create?steps[0][app]=ZestCLIAPI@latest&steps[0][action]=new_feedback"
                    title="Build a new Zap" class="btn-zapier">
                    Build a new Zap
                </a>
            </div>
        </div>

    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'

export default {

    props: ['the_trigger'],

    components: {
        Toggle
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            this.engine = JSON.parse(this.the_trigger.engine)
        }
    },

    data() {
        return {
            trigger: null,
            engine: {}
        }
    },

    mounted: function () {
        //console.log(this.engine);
    },

    methods: {
        toggleZapier: function (checked) {
            this.trigger.enabled = checked ? 1 : 0
            this.updateTrigger()
        },
        toggle: function () {
            if (this.trigger.enabled == 1) {
                this.trigger.enabled = 0;
            } else {
                this.trigger.enabled = 1;
            }
            this.updateTrigger();
        },
        deleteTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/trigger/' + this.trigger.id + '/delete';
            var params = {};
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    this.trigger = null
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Saved", options)
                })
                .catch(e => {
                    console.error(e);
                });
        },
        updateTrigger: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            let url = this.$page.props.api_url + '/v1/trigger/' + this.trigger.id;
            var params = {
                enabled: this.trigger.enabled
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        }
    }
}

</script>

<style scoped>
a.btn-zapier {
    display: inline-block;
    text-decoration: none;
    color: #E65528;
    text-indent: -9999px;
    font-size: 0.1rem;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    background: #E65528 url(/img/zapier-full.svg) no-repeat center center;
    width: 139px;
    height: 40px;
    border-radius: 6.5px;
    background-size: 50%;
}
</style>
